import {
  Command,
  EditMediaWidgetStyleProps,
  EditWidgetStyleInYoutubeWidgetCommand,
} from '../../../../types/commands';

export const editYoutubeWidgetStyleCommand = ({
  aggregateId,
  aggregateVersion,
  chapterId,
  pageId,
  sectionId,
  columnIndex,
  widgetId,
  widgetStyle,
}: EditMediaWidgetStyleProps): EditWidgetStyleInYoutubeWidgetCommand => ({
  aggregateId,
  aggregateVersion,
  command: Command.EDIT_STYLE_IN_YOUTUBE_WIDGET,
  payload: {
    chapterId,
    pageId,
    sectionId,
    columnIndex,
    widgetId,
    style: widgetStyle,
  },
});
